// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gZ","advertCardPhoto__image":"c-a_ha"};